import { PanelMaterial } from "./PanelMaterial";
import {BackrestLightType} from "./BackRestLightType";
import { BenchMaterial } from "./BenchMaterial";
import { Stove } from "./Stove";
import { BenchModel } from "./BenchModel";
export class Sauna {
    Model: BenchModel;
    benchProductLine:BenchProductLine;
    Size: string;
    PanelMaterial: PanelMaterial;
    backrestLightType:BackrestLightType;
    benchMaterial:BenchMaterial;
    profileMaterial:BenchMaterial;
    stove:Stove;
    roofLight:boolean;
    bottomBenchLight: boolean;
    stoveLight: boolean;
    renderFrontWall: boolean;

    constructor(
        Model: BenchModel,
        benchProductLine:BenchProductLine,
        benchMaterial:BenchMaterial,
        profileMaterial:BenchMaterial,
        Size: string,
        PanemMaterial: PanelMaterial,
        backrestLightType:BackrestLightType,
        roofLight:boolean,
        bottomBenchLight: boolean,
        stoveLight: boolean,
        renderFrontWall: boolean,
        stove:Stove
        ) {
        this.Model = Model;
        this.Size = Size;
        this.PanelMaterial = PanemMaterial;
        this.backrestLightType =backrestLightType
        this.benchProductLine = benchProductLine;
        this.benchMaterial = benchMaterial;
        this.profileMaterial= profileMaterial;
        this.stove =stove;
        this.roofLight=roofLight;
        this.bottomBenchLight = bottomBenchLight;
        this.renderFrontWall = renderFrontWall;
        this.stoveLight = stoveLight;
    }
}
